export const MODAL_KEY = 'CreateEmptyBlankPage'
